'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

let NoflakeTag = /*#__PURE__*/function (NoflakeTag) {
  NoflakeTag["TRACK_FE"] = "noflake.track_fe";
  NoflakeTag["COMPONENT_PLATFORM"] = "noflake.component_platform";
  NoflakeTag["NARVAR_JS"] = "noflake.narvar_js";
  NoflakeTag["BAD"] = "BAD";
  NoflakeTag["RETURNS"] = "noflake.returns";
  NoflakeTag["HIPAA_RETURNS"] = "noflake.hipaa_returns";
  NoflakeTag["SHOPIFY_RETURNS"] = "noflake.shopify_returns";
  NoflakeTag["GEN_AI_RESPONSE_EVENTS"] = "noflake.gen_ai_response_events";
  NoflakeTag["ASSIST_FE"] = "noflake.assist_fe";
  return NoflakeTag;
}({});

exports.NoflakeTag = NoflakeTag;
